import words from 'lodash/words';

import { isEmpty } from './generic';

const isInsufficientText = (text: string = ''): boolean => {
  return isEmpty(text) || words(text).length < 2 || text.trim().length < 6;
};

const isDisabled = (text: string, isLoading: boolean): boolean => {
  return isEmpty(text) || isInsufficientText(text) || isLoading;
};

export const tooltipContent = (
  text: string,
  isLoading: boolean,
  label: string,
): string => {
  if (isEmpty(text)) {
    return 'No text to improve';
  }
  if (isInsufficientText(text)) {
    return 'Not enough text to improve';
  }
  if (isLoading) {
    return 'Improving reply...';
  }
  return label ?? 'Improve reply';
};

export const improveReplyUtils = {
  isInsufficientText,
  getStatus(options: { text: string; isLoading?: boolean; label?: string }): {
    isDisabled: boolean;
    tooltipContent: string;
    isInsufficientText: boolean;
  } {
    return {
      isDisabled: isDisabled(options.text, !!options.isLoading),
      tooltipContent: tooltipContent(
        options.text,
        !!options.isLoading,
        options.label ?? '',
      ),
      isInsufficientText: isInsufficientText(options.text),
    };
  },
};
